import { render, staticRenderFns } from "./invoices-table.vue?vue&type=template&id=47490af1&"
import script from "./invoices-table.vue?vue&type=script&lang=ts&"
export * from "./invoices-table.vue?vue&type=script&lang=ts&"
import style0 from "./invoices-table.vue?vue&type=style&index=0&id=47490af1&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports